var ajaxErrorFormSteps = false;
jQuery(document).ready(function ($) {
    var ajaxSchool = null;
    var timeOutAjaxSchool = null;
    var ajaxPassword = null;
    var timeOutAjaxPassword = null;
    
    // stuff here

    //Init MultiSelect plugin
    $('.multi').multiSelect();

    //Init Sortable
    $( "#sortable" ).sortable({
        update: function( event, ui ) {
            let sort = 1;
            let order = [];
            $( "#sortable li").each(function(){
                let scriptID = $(this).data('script-id');
                $(this).data('sort', sort);
                order.push({scriptID: scriptID, sort: sort});
                if(typeof tinymce !== 'undefined'){
                    tinymce.execCommand( 'mceRemoveEditor', false, 'the_script_tiny_'+scriptID );
                    tinymce.execCommand( 'mceAddEditor', false, 'the_script_tiny_'+scriptID );
                }
                sort++;
            });
            let formData = new FormData();
            formData.append('nonce', jsNonce.nonce);
            formData.append('method', 'sortTheScript');
            formData.append('sort', JSON.stringify(order));
            ajaxCall(formData, $( "#sortable" ), () => {}, () => {});
            
        },
        over: function( event, ui ) {
            console.log("gfdgdfhghrt");
            $( "#sortable li").each(function(){
                let scriptID = $(this).data('script-id');
                if(typeof tinymce !== 'undefined'){
                    tinymce.execCommand( 'mceRemoveEditor', false, 'the_script_tiny_'+scriptID );
                    tinymce.execCommand( 'mceAddEditor', false, 'the_script_tiny_'+scriptID );
                }
            });
        }
    });
    //init characters and words count
    setTimeout(() => {
        $('.charactercount').trigger('input');
        $('.wordcount').trigger('input');
    }, 200);


    //Smooth scrolling with links
    $('a[href^=\\#]').on('click', function(event){     
        //event.preventDefault();
        if(typeof $(this.hash).offset() === 'undefined') return;
        $('html,body').animate({scrollTop:$(this.hash).offset().top}, 500);
    });

    //Init datatable for .list class
    let table = $('.list').DataTable({
        responsive: true,
        dom: 'rt<"bottom"Blip><"clear">',
        "order": [],
        "columnDefs": [ {
            "targets"  : 'no-sort',
            "orderable": false,
        }],
        buttons: [{
            extend: 'collection',
            text: 'Export',
            buttons: [
                {
                    extend: 'excel',
                    exportOptions: {
                        columns: "th:not(.noExport)"
                    }
                }, {
                    extend: 'csv',
                    exportOptions: {
                        columns: "th:not(.noExport)"
                    }
                }
            ]
        }],
        "initComplete": function( settings ) {
            var api = new $.fn.dataTable.Api( settings );
            $.each(settings.aoColumns, function(i){
                if(typeof $(settings.aoColumns[i].nTh).data('search') !== "undefined" 
                    && typeof $(settings.aoColumns[i].nTh).data('search-method') !== "undefined"){
                    $("#" + $(settings.aoColumns[i].nTh).data('search')).on($(settings.aoColumns[i].nTh).data('search-method'), function(){
                        api.column(settings.aoColumns[i].idx).search($(this).val()).draw();
                    });
                }
                if($(settings.aoColumns[i].nTh).hasClass('hide')){
                    api.column(settings.aoColumns[i].idx).visible(false);
                }
            });
        }
    });

    //Ajax table
    $('.listAjax').each(function () {
        var method = $(this).data("method");
        $(this).DataTable({
            ajax: {
                'type': 'POST',
                'url': jsNonce.urlAjax,
                'data': {
                    action: 'vf_ajax',
                    nonce: jsNonce.nonce,
                    method: method,
                },
            },
            serverSide: true,
            processing: true,
            responsive: true,
            dom: 'rt<"bottom"Blip><"clear">',
            "order": [],
            "columnDefs": [ {
                "targets"  : 'no-sort',
                "orderable": false,
            }],
            buttons: [
                'csv'
            ],
            "initComplete": function( settings ) {
                var api = new $.fn.dataTable.Api( settings );
                $.each(settings.aoColumns, function(i){
                    if(typeof $(settings.aoColumns[i].nTh).data('search') !== "undefined" 
                        && typeof $(settings.aoColumns[i].nTh).data('search-method') !== "undefined"){
                        $("#" + $(settings.aoColumns[i].nTh).data('search')).on($(settings.aoColumns[i].nTh).data('search-method'), function(){
                            api.column(settings.aoColumns[i].idx).search($(this).val()).draw();
                        });
                    }
                    if($(settings.aoColumns[i].nTh).hasClass('hide')){
                        api.column(settings.aoColumns[i].idx).visible(false);
                    }
                });
            }
        });
    });
    $(document).on('click', '.backHistoryBtn', function(e){
        e.preventDefault();
        history.back();
    });
    $(document).on('click', '.tab', function(e) {
        let group = $(this).data('group');
        let tab = $(this).data('tab');
        $('.tab[data-group="'+group+'"]').removeClass('active');
        $(this).addClass('active');
        $('#'+group+' .tabGroup').removeClass('active');
        $('#'+group+' '+tab).addClass('active');
    });

    //Listener for search field (.list class only)
    $('#tableSearch').keyup(function(){
        table.search($(this).val()).draw() ;
    }); 

    //Creates table with no header (.basic class)
    $('table.basic').dataTable( {
        "ordering": false,
        "bFilter": false, //Disable search function
        "bJQueryUI": true, //Enable smooth theme
        "sPaginationType": "full_numbers", //Enable smooth theme
        "sDom": 't',
        "drawCallback": function( settings ) {
            $(this).find("thead").remove(); 
        }
    });

    //Creates table with no pagination 
    $('table.nopagination').dataTable( {
        "ordering": false,
        "bFilter": false, //Disable search function
        "bJQueryUI": true, //Enable smooth theme
        "sPaginationType": "full_numbers", //Enable smooth theme
        "sDom": 't',
    });

    //Checkbox selection listener
    $('.menuSelected').remove('d-none');
    $('#selectAll').on('change', function(){
        $( ".selectItem" ).prop( "checked", $('#selectAll').prop("checked") );
        if($('#selectAll').prop("checked")){
            $('.menuSelected').removeClass('d-none');
        } else {
            $('.menuSelected').addClass('d-none');
        }
        $('.menuSelectedSingle').addClass('d-none');
    });
    $( ".selectItem" ).on('change', function(){
        if($( ".selectItem:checked" ).length > 0){
            if($( ".selectItem:checked" ).length != $( ".selectItem" ).length){
                $('#selectAll').prop("checked", false);
            } else {
                $('#selectAll').prop("checked", true);
            }
            if($( ".selectItem:checked" ).length == 1){
                $('.menuSelectedSingle').removeClass('d-none');
            } else {
                $('.menuSelectedSingle').addClass('d-none');
            }
            $('.menuSelected').removeClass('d-none');
        } else {
            $('.menuSelected').addClass('d-none');
            $('.menuSelectedSingle').addClass('d-none');
        }
    });
    //end checkbox listener

    //On delete click
    $(document).on('click', '.delete', function(e) {
        let deleteTitle = $(this).data('delete-title');
        let deleteText = $(this).data('delete-text');
        let deleteConfirm = $(this).data('delete-confirm');
        let deleteId = $(this).data('delete-id');
        Swal.fire({
            title: deleteTitle,
            text: deleteText,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: deleteConfirm,
          }).then((result) => {
            if (result.isConfirmed) {
                $('.deleteTrigger').val(deleteId);
                $('.deleteTrigger').trigger('click');
            }
          })
    });
    $(document).on('click', '.updateScriptList', function(e) {
        $('.afterblock').html('');
        $('#sortable li').each(function(){
            let title = $(this).find('.script--title').html();
            let order = $(this).data('sort');          
            $('.afterblock').append($('<option>', {
                value: order,
                text: order+" - "+title
            }));
        });
        if($('#sortable li').length == 0){
            $('.afterblock').append($('<option>', {
                value: 0,
                text: 'First'
            }));
        }
    });
    
    $(document).on('click', '.delete_ajax', function(e) {
        e.preventDefault();
        let deleteTitle = $(this).data('delete-title');
        let deleteText = $(this).data('delete-text');
        let deleteConfirm = $(this).data('delete-confirm');
        //$this = $(this);
        Swal.fire({
            title: deleteTitle,
            text: deleteText,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: deleteConfirm,
          }).then((result) => {
            if (result.isConfirmed) {
                $(this).parent('form').submit();
            }
          })
    });
    $(document).on('click', '.modal', function(e) {
        var id = $(this).data('modal');
        var html = $('#'+id).contents();
        $('#'+id).html('');
        if(html.length == 0){
            html = $('#'+id).data('html');
        } else {
            $('#'+id).data('html', html);
        }
        Swal.fire({
            html: html,
            showCancelButton: false,
            showConfirmButton: false,
            showCloseButton: true,
            focusConfirm: false,
            width: 990,
            }); 
        if(typeof tinymce !== 'undefined'){
            tinymce.execCommand( 'mceRemoveEditor', false, 'blockcontent' );
            tinymce.execCommand( 'mceAddEditor', false, 'blockcontent' );
        }
    });
    // menu click event
    $('.menuBtn').click(function () {
        $(this).toggleClass('act');
        if ($(this).hasClass('act')) {
            $('.main-navigation').addClass('act');
        }
        else {
            $('.main-navigation').removeClass('act');
        }
    });
    $('.form-radio .form-check-label').click(function () {
        $('.form-check-label').parent().css('background-color', '#FFFFFF');
        $(this).parent().css('background-color', '#E7EFF3');
    });
    $(document).on('submit input change unblur', '.ajax_form', function(e) {
        e.preventDefault();
        let trigger = $(this).data('trigger');
        if(typeof trigger === 'undefined'){
            trigger = 'submit'; //default value
        }
        if(!trigger.split(",").includes(e.type)){
            return;
        }
        let callback = $(this).data('callback');
        let error = $(this).data('error');
        let method = $(this).data('method');
        let formData = new FormData(this);
        formData.append('nonce', jsNonce.nonce);
        formData.append('method', method);
        ajaxCall(formData, $(this), callback, error);
    });
    // School search event
    $('.schoolSearch').on("input", function () {
        let $this = $(this);
        $this.val($this.val());
        if ($('#schoolid').val() != "") {
            $this.val('');
            $('#schoolid').val("");
        } else {
            $('#schoolList ul').html('');
            $('#schoolList').addClass('d-none');
        }
        if (timeOutAjaxSchool) {
            clearTimeout(timeOutAjaxSchool);
        }
        timeOutAjaxSchool = setTimeout(function () {
            if ($this.val().length > 3) {
                if (ajaxSchool) {
                    ajaxSchool.abort();
                }
                ajaxSchool = $.ajax({
                    type: "POST",
                    url: jsNonce.urlAjax,
                    data: {
                        action: 'get_schools_search',
                        nonce: jsNonce.nonce,
                        school: $this.val(),
                        county: $('#schoolcounty').val(),
                    },
                    success: function (response) {
                        $('#schoolList ul').html('');
                        var jsonData = JSON.parse(response);
                        if (jsonData.success == "1") {
                            $('#schoolList').removeClass('d-none');
                            if (jsonData.data.length == 0) {
                                $('#schoolList ul').append("<li>Nothing found</li>");
                            }
                            for (var i = 0; i < jsonData.data.length; i++) {
                                $('#schoolList ul').append("<li class='school-selected' data-id='" + jsonData.data[i].SchoolID + "'>" + jsonData.data[i].SchoolName + " - " + jsonData.data[i].County +" (" + jsonData.data[i].RollNumber + ")" + "</li>");
                            }
                            $('.school-selected').unbind('click');
                            $('.school-selected').on('click', function () {
                                $('.schoolSearch').val($(this).text());
                                $('#schoolid').val($(this).data('id'));
                                $('#schoolList').addClass('d-none');
                                $('#schoolList ul').html('');
                            });
                        } else {
                            alert(jsonData.message);
                        }
                    }
                });
            }
        }, 700);
    });
    $('.schoolSearch').on("blur", function () {
        let $this = $(this);
        setTimeout(function(){
            if ($('#schoolid').val() == "") {
                $this.val('');
                $('#schoolList').addClass('d-none');
                $('#schoolList ul').html('');
            }
        }, 500);
    });
    $(document).on('blur', '.validateOnBlur', function(e) {
        let value = $(this).val();
        let validateType = $(this).data("validate-type");
        let validateto = $(this).data("validate-to");
        if(validateType == 'eircode'){
            value = value.replace(/ /g, "").toUpperCase();
            let test = isEircode(value) || isPostCode(value);
            if(!test){
                $(this).val('');
                $(this).parent().find('.validate-feedback').show();
            } else {
                $(this).val(value);
                $(this).parent().find('.validate-feedback').hide();
            }
        }
        if(validateType == 'email'){
            let test = isEmail(value);
            if(!test){
                $(this).val('');
                $(this).parent().find('.validate-feedback').show();
            } else {
                $(this).val(value);
                $(this).parent().find('.validate-feedback').hide();
            }
        }
        if(validateType == 'compare'){
            let compareTo = $(validateto);
            compareTo = compareTo ? compareTo.val(): "";
            if(compareTo != value){
                $(this).val('');
                $(this).parent().find('.validate-feedback').show();
            } else {
                $(this).parent().find('.validate-feedback').hide();
            }
        }
    });
    
    $(document).on('click', '.resendRegistrationEmail', function(e) {
        let userId = $(this).data('user-id');
        Swal.fire({
            title: "Resend validation email?",
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: 'Yes',
            denyButtonText: `Cancel`,
          }).then((result) => {
            if (result.isConfirmed) {
                $('.resendRegistrationEmailToken').val(userId);
                $('.resendRegistrationEmailToken').trigger('click');
            }
          })
    });
    $(document).on('click', '.submitValidate', function(e) {
        e.preventDefault();
        if (typeof tinyMCE !== 'undefined') {
            tinyMCE.triggerSave();
        }
        let form = $(this).data("validate-form");
        let container = $(this).data("validate-container");
        let isValid = validateInputsInContainer($(container)[0]);

        let titleAlert = $(this).data('confirm-title');
        let messageAlert = $(this).data('confirm-message');
        
        if(typeof titleAlert !== 'undefined' && isValid){
            Swal.fire({
                title: titleAlert,
                text: messageAlert,
                showDenyButton: true,
                showCancelButton: false,
                confirmButtonText: 'Yes',
                denyButtonText: `Cancel`,
              }).then((result) => {
                if (result.isConfirmed) {
                    $(this).removeClass('submitValidate').trigger('click');
                }
              })
        } else if(isValid){
            $(this).removeClass('submitValidate').trigger('click');
        }
    });
    $('.passwordValidation').on('input', function(){
        let $this = $(this);
        if (timeOutAjaxPassword) {
            clearTimeout(timeOutAjaxPassword);
        }
        timeOutAjaxPassword = setTimeout(function () {
            if (ajaxPassword) {
                ajaxPassword.abort();
            }
            ajaxPassword = $.ajax({
                type: "POST",
                url: jsNonce.urlAjax,
                data: {
                    action: 'get_password_check',
                    nonce: jsNonce.nonce,
                    password: $this.val(),
                    token: $('#token').val()
                },
                success: function (response) {
                    var jsonData = JSON.parse(response);
                    if (jsonData.success) {
                        console.log();
                        $this.parent().find('.password-check .length').removeClass('invalid valid').addClass(jsonData.lengthpass);
                        $this.parent().find('.password-check .number').removeClass('invalid valid').addClass(jsonData.number);
                        $this.parent().find('.password-check .name').removeClass('invalid valid').addClass(jsonData.name);
                        $this.parent().find('.password-check .special').removeClass('invalid valid').addClass(jsonData.special);
                    } else {
                        console.log(response);
                    }
                    let dataValue = response.indexOf("invalid") >= 0 ? "false" : "true";
                    $this.data('password-valid', dataValue);
                }
            });
        }, 100);
    });
    $('.passwordValidation').on('blur', function(){
        if($(this).data('password-valid') == "false"){
            $(this).val('');
            $(this).parent().find('.password-check span').removeClass('valid').addClass('invalid');
        }
    }); 
    $('#confirmpassword').on('input', function(){
        if($(this).val() == $('#password').val()){
            $(this).parent().find('.password-check .match').removeClass('invalid').addClass('valid');
        } else {
            $(this).parent().find('.password-check .match').removeClass('valid').addClass('invalid');
        }
    }); 
    $(document).on('change', '.nqcheckbox', function(e) {
        let countChecked = $('.nqcheckbox:checked').length;
        if(countChecked  > 2){
            $(this).prop('checked', false);
        }
        if($(this).hasClass('unique') && $(this).prop('checked')){
            $('.nqcheckbox').prop('checked', false);
            $(this).prop('checked', true);
        }
        let uniqueCount = $('.nqcheckbox.unique:checked').length;
        if(uniqueCount > 1){
            $(this).prop('checked', false);
        }
    }); 
    $(document).on('change', '.markaspaidcheckbox', function(e) {
        let countChecked = $('.markaspaidcheckbox:checked').length;
        if(countChecked  == 1){
            $('.paidbulk').addClass('d-none');
            $('.paid').removeClass('d-none');
        } else {
            $('.paidbulk').removeClass('d-none');
            $('.paid').addClass('d-none');
        }
    });
    $(document).on('change', '.markAsPresent', function(e) {
        let userExhibitionID = $(this).val();
        let checked = $(this).is(':checked');
        $.ajax({
            type: "POST",
            url: jsNonce.urlAjax,
            data: {
                action: 'mark_as_present',
                nonce: jsNonce.nonce,
                userExhibitionID: userExhibitionID,
                checked: checked ? 1 : 0
            },
            success: function (response) {
                var jsonData = JSON.parse(response);
                let icon = jsonData.success ? 'success' : 'error'; 
                Swal.fire({
                    position: 'bottom-end',
                    icon: icon,
                    showConfirmButton: false,
                    timer: 1000
                  })
            }
        });
        console.log(userExhibitionID, checked);
    });
    $(document).on('click', '.saveScreening', function(e) {
        let projectID = parseInt($('#projectid').val());
        if(parseInt($('#statusid').val()) == 6){
            let countChecked = $('.nqcheckbox:checked').length;
            let uniqueCount = $('.nqcheckbox.unique:checked').length;
            console.log(countChecked, uniqueCount);
            if(countChecked >= 2 && uniqueCount > 0){
                Swal.fire({
                    icon: 'error',
                    text: 'You must select only one non qualifying reason when selecting a reserved reason',
                    showCancelButton: false,
                    confirmButtonText: 'Ok',
                    }).then((result) => {
                        if (result.isConfirmed) {
                            $('.assessProject[data-id="'+projectID+'"]').trigger('click');
                        }
                    });
                  return;
            } else if(countChecked < 2 && uniqueCount == 0) {
                Swal.fire({
                    icon: 'error',
                    text: 'You must select two non qualifying reasons',
                    showCancelButton: false,
                    confirmButtonText: 'Ok',
                    }).then((result) => {
                        if (result.isConfirmed) {
                            $('.assessProject[data-id="'+projectID+'"]').trigger('click');
                        }
                    });
                  return;
            }
        }
        let data = {
            action: 'on_screening',
            nonce: jsNonce.nonce
        };
        data = $('#assessmentForm').serialize() + '&' + $.param(data);
        $.ajax({
            type: "POST",
            url: jsNonce.urlAjax,
            data: data,
            success: function (response) {
                var jsonData = JSON.parse(response);
                let icon = jsonData.success ? 'success' : 'error';
                swal.close();
                Swal.fire({
                    position: 'bottom-end',
                    icon: icon,
                    showConfirmButton: false,
                    timer: 1000
                  })
            }
        });
    });
    $(document).on('input', '.wordcount', function(e) {
        let maxWords = parseInt($(this).data('max-words'));
        let text = $(this).val();
        let wordCount = text.trim().split(/\s+/).length;
    
        if (wordCount > maxWords) {
            let words = text.match(/\S+/g);
            let truncatedText = words.slice(0, maxWords).join(' ');
            $(this).val(truncatedText);
            wordCount = maxWords;
        }
    
        let wordsRemaining = maxWords - wordCount;
        $(this).parent().find('.counter').html(wordsRemaining);
    });
    

    $(document).on('input', '.charactercount', function(e) {
        let maxCharacters = parseInt($(this).data('max-characters'));
        let text = $(this).val();
        let charactersremaining = maxCharacters - text.length;
        if(text.length > maxCharacters){
            charactersremaining = 0;
            $(this).val(text.substring(0, maxCharacters));
        }
        $(this).parent().find('small .counter').html(charactersremaining);
    });
    $('.uniquecheck').on('change', function(){
        $('.uniquecheck').not(this).removeAttr('checked');
    });
    $('#numberstudents').on('change', function(){
        $('.extrastudentdiv').addClass('d-none');
        $('.extrastudent').removeClass('required');
        let numberStudents = parseInt($(this).val());
        console.log(numberStudents);
        if(numberStudents > 1){
            for(let i = 2; i <= numberStudents; i++){
                $('#student'+i).removeClass('d-none');
                $('#student'+i+' input.extrastudent').addClass('required');
            }
        }
    })

    $('.markaspaid').on('click', function(){
        let selectedProjects = [];
        $("#selectedProjects:checked").each(function(){
            selectedProjects.push($(this).val());
        });
        $.ajax({
            type: "POST",
            url: jsNonce.urlAjax,
            data: {
                action: 'make_payment',
                nonce: jsNonce.nonce,
                projects: selectedProjects
            },
            success: function (response) {
                var jsonData = JSON.parse(response);
                Swal.fire({
                    html: jsonData.html,
                    showCancelButton: false,
                    showConfirmButton: false,
                    focusConfirm: false,
                    width: 900,
                  });
                  $('table.markaspaid').dataTable( {
                    "ordering": false,
                    "bFilter": false, //Disable search function
                    "bJQueryUI": true, //Enable smooth theme
                    "sPaginationType": "full_numbers", //Enable smooth theme
                    "sDom": 't',
                });  
            }
        });
    });

    $('.assessProject').on('click', function(){
        let projectID = $(this).data('id');
        $.ajax({
            type: "POST",
            url: jsNonce.urlAjax,
            data: {
                action: 'screening',
                nonce: jsNonce.nonce,
                projectID: projectID
            },
            success: function (response) {
                var jsonData = JSON.parse(response);
                Swal.fire({
                    html: jsonData.html,
                    showCancelButton: false,
                    showConfirmButton: false,
                    focusConfirm: false,
                    width: 900,
                });
                $('table.basic').dataTable( {
                    "ordering": false,
                    "bFilter": false, //Disable search function
                    "bJQueryUI": true, //Enable smooth theme
                    "sPaginationType": "full_numbers", //Enable smooth theme
                    "sDom": 't',
                    "drawCallback": function( settings ) {
                        $(this).find("thead").remove(); 
                    }
                });
            }
        });
    });

    $('.categoryChange').on('change', function(){
        if(parseInt($(this).val()) == 3 || parseInt($(this).val()) == 6){
            $('.socialquestions').removeClass("d-none");
            $('.socialquestions input').removeClass("requiredCategory").addClass('required');
            $('.socialquestions textarea').removeClass("requiredCategory").addClass('required');
        } else {
            $('.socialquestions').addClass("d-none");
            $('.socialquestions input').removeClass("required").addClass('requiredCategory');
            $('.socialquestions textarea').removeClass("required").addClass('requiredCategory');
        }
    });


    //Project status change to show NQ Reasons
    $(document).on('change', '#statusid', function(e) {
        if (parseInt($(this).val()) == 6) {
            $('#nqBlock').removeClass('d-none');
            $('#nqBlock .form-check-input').addClass('required');
        } else {
            $('#nqBlock').addClass('d-none');
            $('#nqBlock .form-check-input').removeClass('required');
        }
    });

    //Menu and submenu click listener
    $('a.menuClick').on('click', function(event){     
        event.preventDefault();
        let href = $(this).attr('href');
        let menu = $(this).data('menu');
        let submenu = $(this).data('submenu');
        let subsubmenu = $(this).data('subsubmenu');
        $.ajax({
            type: "POST",
            url: jsNonce.urlAjax,
            data: {
                action: 'menu',
                nonce: jsNonce.nonce,
                menu: menu,
                submenu: submenu,
                subsubmenu: subsubmenu
            },
            success: function (response) {
                window.location.href = href;
            }
        });
    });
    $(document).on('click', '.editBtnScript', function(e) {
        let el = $(this).parent().parent().parent();
        el.find('.edit-script').toggleClass('d-none');
        console.log(el);
    });
    $(document).on('change', '.score_calculate', function(e) {
        let total = 0;
        $('.score_calculate').each(function(){
            let score = parseInt($(this).val());
            score = isNaN(score) ? 0 : score;
            total = total + score;
        });
        $('#totalScore').val(total);
    });
});
function confirmPopup(response){
    var timer = typeof response !== 'undefined' && typeof response.timer !== 'undefined' ? parseInt(response.timer) : 1000;
    Swal.fire({
        position: 'bottom-end',
        icon: 'success',
        text: response.text,
        showConfirmButton: false,
        timer: timer
      })
}
function confirmPopupRefresh(response){
    confirmPopup(response);
    var timer = typeof response !== 'undefined' && typeof response.timer !== 'undefined' ? parseInt(response.timer) : 1000;
    var url = typeof response !== 'undefined' && typeof response.url !== 'undefined' ? response.url : null;
    setTimeout(() => {
        if(url == null){
            location.reload();
        } else {
            window.location = url;
        }
        
    }, timer);
    
}
function errorPopup(response){
    var timer = typeof response !== 'undefined' && typeof response.timer !== 'undefined' ? parseInt(response.timer) : 1000;
    Swal.fire({
        position: 'bottom-end',
        icon: 'error',
        text: response.text,
        showConfirmButton: true,
        timer: timer
      })
}
function errorPopupSteps(response){
    ajaxErrorFormSteps = true;
    var timer = typeof response !== 'undefined' && typeof response.timer !== 'undefined' ? parseInt(response.timer) : 1000;
    Swal.fire({
        position: 'bottom-end',
        icon: 'error',
        text: response.text,
        showConfirmButton: true,
        timer: timer
      })
    
}


function confirmTheScriptEditPopup(response){
    let scriptID = response.scripts.TheScriptID;
    let scriptTitle = response.scripts.ScriptTitle;
    let scriptBody = htmlDecode(response.scripts.ScriptDescription);
    let el = jQuery('[data-script-id="'+scriptID+'"]');
    el.find('.edit-script').toggleClass('d-none');
    el.find('.script--title').html(scriptTitle);
    el.find('.script--body').html(scriptBody);
    confirmPopup(response);
}
function confirmUserSave(response){
    Swal.close();
    confirmPopup(response);
}
function confirmPopupTheScript(response){
    jQuery('#theScriptForm').submit();
    confirmPopup(response);
}
function confirmPopupDeleteScriptBlock(response){
    let id = response.scriptID;
    let el = jQuery('[data-script-id="'+id+'"]').remove();
    confirmPopup(response);
}
function confirmPopupStandNumber(response){
    if(typeof response !== 'undefined' &&
        typeof response.projectid !== 'undefined' &&
        typeof response.standNo !== 'undefined'){
        jQuery('#standNoSpan'+response.projectid).html(response.standNo);
    }
    confirmPopup(response);
}
function confirmPopupAwardAssignment(response){
    if(typeof response !== 'undefined' &&
        typeof response.awardID !== 'undefined'){
        jQuery('#projecttype'+response.awardID).html(response.projectType);
        jQuery('#projecttitle'+response.awardID).html(response.projectTitle);
    }
    confirmPopup(response);
}
function confirmTheScript(response){
    if(typeof response !== 'undefined' &&
        typeof response.html !== 'undefined'){
        jQuery('#sortable').html(response.html);
        setTimeout(function(){
            jQuery( "#sortable li").each(function(){
                let scriptID = jQuery(this).data('script-id');
                if(typeof tinymce !== 'undefined'){
                    tinymce.execCommand( 'mceRemoveEditor', false, 'the_script_tiny_'+scriptID );
                    tinymce.execCommand( 'mceAddEditor', false, 'the_script_tiny_'+scriptID );
                }
            }); 
        }, 500);
    }
}
function errorTheScript(response){
    $('#sortable').html(response.text);
}
function errorPopupAwardAssignment(response){
    if(typeof response !== 'undefined' &&
        typeof response.awardID !== 'undefined'){
        jQuery('#standno'+response.awardID).val("");
    }
    errorPopup(response);
}
function errorUserSave(response){
    errorPopup(response);
}
function errorPopupStandNumber(response){
    if(typeof response !== 'undefined' &&
        typeof response.projectid !== 'undefined' &&
        typeof response.standNo !== 'undefined'){
        jQuery('#standNoSpan'+response.projectid).html(response.standNo);
        jQuery('#standnumber'+response.projectid).val(response.standNo);
    }
    errorPopup(response);
}
function openJudgeRoundModal(response){
    openAjaxHtmlModal(response);
    jQuery('table.basic').dataTable( {
        "ordering": false,
        "bFilter": false, //Disable search function
        "bJQueryUI": true, //Enable smooth theme
        "sPaginationType": "full_numbers", //Enable smooth theme
        "sDom": 't',
        "drawCallback": function( settings ) {
            jQuery(this).find("thead").remove(); 
        }
    });
      
}
function openAjaxHtmlModal(response){
    if(typeof response !== 'undefined' &&
        typeof response.success !== 'undefined'){
    Swal.fire({
        html: response.html,
        showCancelButton: false,
        showConfirmButton: false,
        showCloseButton: true,
        focusConfirm: false,
        focusClose: false,
        width: 900,
      });
      jQuery('.multi').multiSelect();
    } else {
        errorPopup(response);
    }
}
function judgeRoundModalError(response){

}
function openEditUserModal(response){
    jQuery('[data-modal="addEditUser"]').trigger('click');
    populateForm('.swal2-html-container #userAccountSetupForm', response);
}
function populateForm(form, response){
    console.log(response);
    for (var key in response) {
        if (response.hasOwnProperty(key) && jQuery(form + " #" +key.toLowerCase()).length > 0) {
            let input = jQuery(form + " #" +key.toLowerCase());
            if(input[0].tagName == "DIV" && input.hasClass('form-radio')){
                jQuery(form + " #" +key.toLowerCase()+response[key]).prop("checked", true);
            } else {
                jQuery(form + " #" +key.toLowerCase()).val(response[key]);
            }
        }
    }
}
function executeFunctionByName(functionName, context /*, args */) {
    var args = Array.prototype.slice.call(arguments, 2);
    var namespaces = functionName.split(".");
    var func = namespaces.pop();
    for(var i = 0; i < namespaces.length; i++) {
        context = context[namespaces[i]];
    }
    return context[func].apply(context, args);
}
function ajaxCall(formData, form, callback, errorCallback){

    formData.append('action', 'vf_ajax');
    return jQuery.ajax({
        type: "POST",
        url: jsNonce.urlAjax,
        data: formData,
        processData: false,
        contentType: false,
        success: function (response) { 
            try {
                let jsonData = JSON.parse(response);
                if(jsonData.success && typeof callback !== 'undefined' && callback != null){
                    ajaxErrorFormSteps = false;
                    executeFunctionByName(callback, window, jsonData, form);
                    return true;
                } else if(!jsonData.success){
                    ajaxErrorFormSteps = true;
                    if(typeof errorCallback !== 'undefined' && errorCallback != null){
                        executeFunctionByName(errorCallback, window, jsonData, form);
                    }
                    return false;
                }
            } catch (e) {
                ajaxErrorFormSteps = true;
                if(typeof errorCallback !== 'undefined' && errorCallback != null){
                    executeFunctionByName(errorCallback, window, e, form);
                }
                return false;
            }
        },
        error: function(error){
            ajaxErrorFormSteps = true;
            if(typeof errorCallback !== 'undefined' && errorCallback != null){
                executeFunctionByName(errorCallback, window, error, form);
            }
            return false;
        }
    });
}

//Resend 2FA code
function resendCode(urlPage){
    jQuery.ajax({
        type: "POST",
        url: urlPage,
        data: {
            nonce: jsNonce.nonce
        },
        success: function (response) {
            
        }
    });
}
/**
 * Define a function to navigate betweens form steps.
 * It accepts one parameter. That is - step number.
 */
const navigateToFormStep = (stepNumber) => {
    /**
     * Hide all form steps.
     */
    document.querySelectorAll(".form-step").forEach((formStepElement) => {
        formStepElement.classList.add("d-none");
    });
    /**
     * Mark all form steps as unfinished.
     */
    document.querySelectorAll(".form-stepper-list").forEach((formStepHeader) => {
        formStepHeader.classList.add("form-stepper-unfinished");
        formStepHeader.classList.remove("form-stepper-active", "form-stepper-completed");
    });
    /**
     * Show the current form step (as passed to the function).
     */
    document.querySelector("#step-" + stepNumber).classList.remove("d-none");
    /**
     * Select the form step circle (progress bar).
     */
    const formStepCircle = document.querySelector('li[step="' + stepNumber + '"]');
    /**
     * Mark the current form step as active.
     */
    formStepCircle.classList.remove("form-stepper-unfinished", "form-stepper-completed");
    formStepCircle.classList.add("form-stepper-active");
    /**
     * Loop through each form step circles.
     * This loop will continue up to the current step number.
     * Example: If the current step is 3,
     * then the loop will perform operations for step 1 and 2.
     */
    for (let index = 0; index < stepNumber; index++) {
        /**
         * Select the form step circle (progress bar).
         */
        const formStepCircle = document.querySelector('li[step="' + index + '"]');
        /**
         * Check if the element exist. If yes, then proceed.
         */
        if (formStepCircle) {
            /**
             * Mark the form step as completed.
             */
            formStepCircle.classList.remove("form-stepper-unfinished", "form-stepper-active");
            formStepCircle.classList.add("form-stepper-completed");
        }
    }
};
/**
 * Select all form navigation buttons, and loop through them.
 */
document.querySelectorAll(".btn-navigate-form-step").forEach((formNavigationBtn) => {
    /**
     * Add a click event listener to the button.
     */
    formNavigationBtn.addEventListener("click", (event) => {
        let allowNext = true;
        /**
         * Get the value of the step.
         */
        const stepNumber = parseInt(formNavigationBtn.getAttribute("step_number"));
        if (formNavigationBtn.classList.contains('validate')) {
            const stepContainer = document.getElementById('step-' + (stepNumber - 1));
            allowNext = validateInputsInContainer(stepContainer);
        }

        allowNext = validateIfGaeilge(document.getElementById('step-' + (stepNumber - 1)), allowNext);

        /**
         * Call the function to navigate to the target form step if allowed.
         */
        if (allowNext) {
            if (formNavigationBtn.classList.contains('ajax-nav')) {
                
                // Get the necessary data attributes
                const callback = formNavigationBtn.getAttribute('data-callback');
                const error = formNavigationBtn.getAttribute('data-error');
                const method = formNavigationBtn.getAttribute('data-method');
                
                // Create FormData object
                const formData = new FormData();
                formData.append('nonce', jsNonce.nonce);
                formData.append('method', method);

                // Assuming the button is inside a form element
                const formElement = formNavigationBtn.closest('form');
                if (formElement) {
                    new FormData(formElement).forEach((value, key) => {
                        formData.append(key, value);
                    });
                    
                    // Make the AJAX call
                    ajaxCall(formData, formNavigationBtn, callback, error);
                }
            }
            setTimeout(function(){
                if(!ajaxErrorFormSteps){
                    navigateToFormStep(stepNumber);
                }
            }, 1000);
            
            
        }
    });
});


/**
 * If Gaeilge selected, Validate project name & overview (in English) 
 */
function validateIfGaeilge(stepContainer, allowNext) {
    if('2' === jQuery('#language', stepContainer).find(":selected").val()) {
        if(getInputValue(document.getElementById('projectnameEnglish')) == '') {
            document.getElementById('projectnameEnglish').parentNode.classList.add('error');
            allowNext = false;
        }
        if(getInputValue(document.getElementById('projectoverviewEnglish')) == '') {
            document.getElementById('projectoverviewEnglish').parentNode.classList.add('error');
            allowNext = false;
        }
    }
    return allowNext;
}

/**
 * Toggles element visibility 
 */
document.querySelectorAll(".btn-toggle").forEach((toggleBtn) => {
    /**
     * Add a click event listener to the button.
     */
    toggleBtn.addEventListener("click", () => {
        /**
         * Gets element id that will be toggled
         */
        const elementSelector = toggleBtn.getAttribute("toggle");
        document.querySelectorAll(elementSelector).forEach((elementToggle) => {
            /**
             * Toggles class d-none
             */
            elementToggle.classList.toggle("d-none");

            //Clears inputs inside the element
            let clearInputs = elementToggle.classList.contains("d-none");
            requiredToogle(elementToggle, clearInputs);
        });
    });
});

function requiredToogle(container, clearInputs) {
    var inputs = container.getElementsByTagName('input');
    var selects = container.getElementsByTagName('select');
    for (var index = 0; index < inputs.length; ++index) {
        if(clearInputs) inputs[index].value = '';
        inputs[index].classList.replace('required', 'required2');
        inputs[index].classList.replace('requiredToggle', 'required');
        inputs[index].classList.replace('required2', 'requiredToggle');
    }
    for (var index = 0; index < selects.length; ++index) {
        if(clearInputs) selects[index].value = '';
        selects[index].classList.replace('required', 'required2');
        selects[index].classList.replace('requiredToggle', 'required');
        selects[index].classList.replace('required2', 'requiredToggle');
    }
}
function getInputValue(input){
    let value = "";
    if(input.tagName == "INPUT" || input.tagName == "TEXTAREA"){
        if (input.type == "checkbox" || input.type == "radio") {
            let el = document.querySelector('input[name="'+input.name+'"]:checked');
            value = el ? el.value : '';
        } else {
            value = input.value;
        }
    } else if(input.tagName == "SELECT"){
        value = input.value;
    }
    return value;
}
function isEmail(email) {
    var regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return regex.test(email);
}
function isPostCode(postCode) {
    var regex = /^([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([AZa-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9]?[A-Za-z]))))[0-9][A-Za-z]{2})$/;
    return regex.test(postCode);
}
function isEircode(eirCode) {
    var regex = /^[AC-FHKNPRTV-Y]\d[0-9W][ -]?[0-9AC-FHKNPRTV-Y]{4}$/;
    return regex.test(eirCode);
}
function validateInputsInContainer(container){
    let allowNext = true;
    container.querySelectorAll(".invalid-feedback").forEach((feedback) => {
        feedback.parentNode.classList.remove('error');
    });
    /**
     * Verifies if all required fields have value
     */
     container.querySelectorAll(".required").forEach((input) => {
        if(getInputValue(input) == ''){
            if(input.type && (input.type == 'radio' || input.type == 'checkbox')){
                input.parentNode.parentNode.parentNode.classList.add('error');
            } else if(input.classList.contains('tiny')) {
                input.parentNode.parentNode.parentNode.classList.add('error');
            } else {
                input.parentNode.classList.add('error');
            }
            allowNext = false;
        }
    });
    return allowNext;
}
function htmlDecode(input){
    var e = document.createElement('div');
    e.innerHTML = input;
    return e.childNodes[0].nodeValue;
}